import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import React from "react";
import iconSizes from "../iconSizes";
import { deprecatedPropValueMessage } from "../../../utils/deprecationUtils";
var isDeprecatedIconSize = function(iconSize) {
    if (typeof iconSize === 'undefined') {
        return false;
    }
    return iconSize === 'xl';
};
var HollowSquareIcon = function(param) {
    var _size = param.size, size = _size === void 0 ? 's' : _size, _color = param.color, color = _color === void 0 ? 'currentColor' : _color, title = param.title;
    if (isDeprecatedIconSize(size)) {
        deprecatedPropValueMessage({
            componentName: 'Icon',
            propName: 'size',
            propValue: 'xl',
            date: 'Q3 2022'
        });
    }
    var ref;
    return _jsxs("svg", {
        focusable: "false",
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: '0 0 32 32',
        css: {
            width: iconSizes[size],
            height: iconSizes[size],
            fill: color
        },
        role: "img",
        "aria-hidden": (ref = !title) !== null && ref !== void 0 ? ref : false,
        children: [
            title && _jsx("title", {
                children: title
            }),
            _jsx("g", {
                children: _jsxs("svg", {
                    viewBox: "0 0 24 24",
                    children: [
                        _jsx("path", {
                            d: "M17.392 2.1a1.1 1.1 0 102.2 0 1.1 1.1 0 00-2.2 0zM13.392 2.1a1.1 1.1 0 102.2 0 1.1 1.1 0 00-2.2 0zM10.492 3.2a1.1 1.1 0 110-2.2 1.1 1.1 0 010 2.2zM5.392 2.1a1.1 1.1 0 102.2 0 1.1 1.1 0 00-2.2 0z"
                        }),
                        _jsx("path", {
                            d: "M19.392 5a1 1 0 00-1-1h-12a1 1 0 00-1 1v14a1 1 0 001 1h12a1 1 0 001-1V5zm-12 1h10v12h-10V6z",
                            fillRule: "evenodd",
                            clipRule: "evenodd"
                        }),
                        _jsx("path", {
                            d: "M22.687 5.9a1.1 1.1 0 11-2.2 0 1.1 1.1 0 012.2 0zM22.687 9.9a1.1 1.1 0 11-2.2 0 1.1 1.1 0 012.2 0zM21.587 15a1.1 1.1 0 100-2.2 1.1 1.1 0 000 2.2zM22.687 17.9a1.1 1.1 0 11-2.2 0 1.1 1.1 0 012.2 0zM3.1 7.4a1.1 1.1 0 100-2.2 1.1 1.1 0 000 2.2zM3.1 11.4a1.1 1.1 0 100-2.2 1.1 1.1 0 000 2.2zM3.1 15.4a1.1 1.1 0 100-2.2 1.1 1.1 0 000 2.2zM17.392 22.1a1.1 1.1 0 102.2 0 1.1 1.1 0 00-2.2 0zM13.392 22.1a1.1 1.1 0 102.2 0 1.1 1.1 0 00-2.2 0zM10.492 23.2a1.1 1.1 0 110-2.2 1.1 1.1 0 010 2.2zM5.392 22.1a1.1 1.1 0 102.2 0 1.1 1.1 0 00-2.2 0zM3.1 19.4a1.1 1.1 0 100-2.2 1.1 1.1 0 000 2.2z"
                        })
                    ]
                })
            })
        ]
    });
};
HollowSquareIcon.isCarinaIcon = true;
export default HollowSquareIcon;
